import React from 'react'

export default function SinglePlayer() {
    return (
        <div className="SinglePlayer">
            <p className="text1">Coming Very Soon!</p>
        </div>
    )
}